export default __webpack_public_path__ + "static/ruda-79d640fe7632b9f2bb6c1a507a7c1e03.png";